import type { ReactElement } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { LoadingScreen } from "./components/ui";
import { useAuth } from "./lib/auth";
import { ExpenseFormPage } from "./pages/ExpenseFormPage";
import { GroupPage } from "./pages/GroupPage";
import { HomePage } from "./pages/HomePage";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { NewGroupPage } from "./pages/NewGroupPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PeoplePage } from "./pages/PeoplePage";
import { ProfilePage } from "./pages/ProfilePage";
import { PublicGroupPage } from "./pages/PublicGroupPage";
import { SignupPage } from "./pages/SignupPage";

/** Segura a rota ate saber se ha sessao; sem isso a tela pisca no reload. */
function Protected({ children }: { children: ReactElement }): ReactElement {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/entrar" replace state={{ from: location.pathname }} />;
  return children;
}

function GuestOnly({ children }: { children: ReactElement }): ReactElement {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

export function App(): ReactElement {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <GuestOnly>
            <LandingPage />
          </GuestOnly>
        }
      />
      <Route
        path="/entrar"
        element={
          <GuestOnly>
            <LoginPage />
          </GuestOnly>
        }
      />
      <Route
        path="/criar-conta"
        element={
          <GuestOnly>
            <SignupPage />
          </GuestOnly>
        }
      />

      {/* O link publico do grupo: sem login, so leitura. */}
      <Route path="/g/:shareToken" element={<PublicGroupPage />} />

      <Route
        path="/app"
        element={
          <Protected>
            <AppShell />
          </Protected>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="grupos/novo" element={<NewGroupPage />} />
        <Route path="grupos/:groupId" element={<GroupPage />} />
        <Route path="grupos/:groupId/despesas/nova" element={<ExpenseFormPage />} />
        <Route path="grupos/:groupId/despesas/:expenseId" element={<ExpenseFormPage />} />
        <Route path="pessoas" element={<PeoplePage />} />
        <Route path="perfil" element={<ProfilePage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
